// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2vTtb","question":"Question_question__3034X","description":"Question_description__hdosu"};